import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { CoreStateService } from '@app/core/services';
import { combineLatest, map, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-card-educational-level',
  templateUrl: './card-educational-level.component.html',
  styleUrls: ['./card-educational-level.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardEducationalLevelComponent implements OnInit, OnDestroy {
  public data$: Observable<any>;

  private _destroy$ = new Subject<void>();

  constructor(
    private coreStateService: CoreStateService,
    private breakpointObserver: BreakpointObserver,
  ) {}

  public ngOnInit() {
    this.loadData();
  }

  public ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }

  private loadData() {
    const levels$ = this.coreStateService.state$.pipe(
      map((config) => config.plugin.educationLevels.filter((level) => level.compare(config.school))),
    );
    const isShowFerrisWheel$ = this.breakpointObserver.observe('(min-width: 1280px)').pipe(
      takeUntil(this._destroy$),
      map((state) => state.matches),
    );

    this.data$ = combineLatest([levels$, isShowFerrisWheel$]).pipe(
      takeUntil(this._destroy$),
      map(([levels, ferrisWheel]) => ({ levels, ferrisWheel })),
    );
  }
}
